import React, { ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  styled,
  Typography,
} from "@mui/material";
import Close from "@material-ui/icons/Close";
import Button from "components/Forms/CustomButtons/ButtonTS";

import { useTranslation } from "react-i18next";

const CustomDialog = styled(Dialog)(() => ({
  "& .MuiPaper-root": {
    borderRadius: "1rem",
  },
}));

interface LogSystemModalProps {
  children: ReactNode;
  modalOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
}

export const LayoutModalWorkerItem: React.FC<LogSystemModalProps> = ({
  children,
  modalOpen,
  onClose,
  title,
  subtitle,
}) => {
  const { t } = useTranslation(["modals"]);

  return (
    <>
      <CustomDialog
        open={modalOpen}
        fullWidth
        maxWidth={"lg"}
        scroll="body"
        onClose={() => {
          onClose();
        }}
        // hideBackdrop
      >
        <DialogTitle>
          <Typography variant="h5" textAlign="center" sx={{ opacity: "0.9" }}>
            {t(title, { ns: "modals" })}
          </Typography>
          <Typography
            variant="subtitle1"
            textAlign="center"
            sx={{ opacity: "0.75" }}
          >
            {subtitle}
          </Typography>
          <Button
            justIcon
            simple
            color="tumblr"
            round
            size="md"
            style={{
              position: "absolute",
              right: "10px",
              top: "10px",
            }}
            onClick={onClose}
          >
            <Close />
          </Button>
        </DialogTitle>
        <Divider style={{ backgroundColor: "#808080", margin: "0rem 2rem" }} />
        <DialogContent
          sx={{
            border: `1px solid #80808080`,
            borderRadius: "1rem",
            boxShadow: "2px 2px 2px rgb(0 0 0 / 20%)",
            margin: "2rem",
          }}
        >
          {children}
        </DialogContent>
      </CustomDialog>
    </>
  );
};
